import axios from "@lib/axios";

export async function getListingPage(slug, locale) {
  const response = await axios.get(`listing_pages/${slug}`, {
    headers: { Language: locale },
  });

  return response.data;
}
